export default "__VITE_ASSET__UhZMw4om__"